import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined"

function EmptyState({
  title = "No se encontraron comprobantes.",
  description = "Ajustá los filtros y volvé a realizar la búsqueda.",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 10,
        px: 3,
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "action.hover",
          color: "text.secondary",
          mb: 1,
        }}
      >
        <ReceiptLongOutlinedIcon sx={{ fontSize: 44 }} />
      </Box>
      <Typography variant="h6" color="text.primary">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {description}
      </Typography>
    </Box>
  )
}

export default EmptyState
